import { AnimatePresence, motion } from 'motion/react'
import React from 'react'
import useWindowSize from '../../hooks/useWindowSize'

const CompanyIconAnimation = ({ showTopRow, imagesOne, imagesTwo }) => {

    const { width, height } = useWindowSize()
    
    const rowVariants = {
        initial: { opacity: 0, y: width <= 360 ? 16 : 20 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -12 }
    }
    
    const transition = { duration: 0.3, ease: "easeInOut" }

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={showTopRow ? "top" : "bottom"}
                variants={rowVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={transition}
                className={`w-full md:w-4/5 lg:w-full mx-auto ${(width <= 360 || height < 720) ? 'h-[51px]' : 'h-[74px]'} lg:h-[90px] mt-3 lg:mt-6 flex gap-3 md:gap-6 items-start overflow-hidden`}
            >
            {(showTopRow ? imagesOne : imagesTwo).map((logo, index) => (
                <div key={index} className="">
                    <img src={logo} alt="" />
                </div>
            ))}
            </motion.div>
        </AnimatePresence>
    )
}

export default CompanyIconAnimation